import React, { useState, useCallback, useEffect } from "react";
import Dustbin from "./DustBinTextImagePhraseType";
import Box from "../../components/BoxText";
import update from "immutability-helper";
import { useRegisterProgress } from "../../hooks/useRegisterProgress";
import styles from "./ImagePhraseType.module.css";

const ImagePhraseType = (props) => {
  const { blockData, datas, shuffledData } = props;
  let [solved, setSolved] = useState(false);
  let title = blockData.complement.titulo ? blockData.complement.titulo : "";
  let start = 0;
  const [dustbins, setDustbins] = useState(getHilighted(props.datas));
  const [droppedBoxNames, setDroppedBoxNames] = useState([]);

  function isDropped(boxName) {
    return droppedBoxNames.indexOf(boxName) > -1;
  }

  useEffect(
    function () {
      if (droppedBoxNames.length === 0 && dustbins.length === 0) {
        setDroppedBoxNames([]);
        setDustbins(getHilighted(props.datas));
        setSolved(false);
      }
    },
    [dustbins, droppedBoxNames]
  );

  useEffect(
    function () {
      setDustbins(getHilighted(props.datas));
    },
    [blockData]
  );

  // Hook to register progress.
  const { registerProgress } = useRegisterProgress(
    blockData.block_id,
    props.lessonId,
    blockData.sectionId,
    blockData.section,
    blockData.num,
    props.totalIndexes,
    "image_phrase_type"
  );

  const handleDrop = useCallback(
    (index, item) => {
      const { name } = item;
      setDroppedBoxNames(
        update(droppedBoxNames, name ? { $push: [name] } : { $push: [] })
      );
      setDustbins(
        update(dustbins, {
          [index]: {
            lastDroppedItem: {
              $set: item,
            },
          },
        })
      );
    },
    [droppedBoxNames, dustbins]
  );
  let array = [];
  let countData = getHilighted(datas).length;

  const solve = async () => {
    let allData = [];
    let allDustBins = dustbins;

    for (let i = 0; i < dustbins.length; i++) {
      allData.push(dustbins[i].word);
      allDustBins[i].lastDroppedItem = { name: dustbins[i].word };
    }

    setDroppedBoxNames(update(droppedBoxNames, { $push: allData }));
    setDustbins(update(dustbins, { $set: allDustBins }));
  };

  const tryAgain = async () => {
    let allDustBins = dustbins;

    for (let i = 0; i < dustbins.length; i++) {
      allDustBins[i].lastDroppedItem = undefined;
    }
    setDroppedBoxNames(update(droppedBoxNames, { $set: [] }));
    setTimeout(() => {
      setDroppedBoxNames(update(droppedBoxNames, { $set: [] }));
    }, 100);

    setDustbins(update(dustbins, { $set: allDustBins }));

    setSolved(false);
  };

  function splitText(getdata, index) {
    let removeParentheses = getdata.match(/\[(.*?)\]/g);

    array.push(removeParentheses[index]);

    start =
      index === 0
        ? start
        : parseInt(
            getdata.indexOf(array[index - 1]) + array[index - 1].length + 1
          );

    let lastString = getdata.indexOf(array[index]);
    let result = getdata.slice(start, lastString);

    return result;
  }

  function lastText(getdata) {
    let lastText = "";

    if (array[countData - 1] !== undefined) {
      lastText = getdata.slice(
        getdata.lastIndexOf(array[countData - 1]) + array[countData - 1].length,
        getdata.length
      );
    }
    return lastText;
  }

  function getHilighted(text) {
    let splitText = text.match(/\[(.*?)\]/g);

    let textObj = [];
    for (let i = 0; i < splitText.length; i++) {
      if (splitText[i].includes("[") || splitText[i].includes("]")) {
        textObj.push({
          word: splitText[i].replace("[", "").replace("]", ""),
          lastDroppedItem: null,
        });
      }
    }

    return textObj;
  }

  function isAllDropped() {
    return dustbins.every((dustbin) => dustbin.lastDroppedItem);
  }

  return (
    <div className={`new-bg-color default-card container`}>
      <div className={styles.imagePhraseTypeContainer}>
        <div>
          <h4>Fill in the blanks with the appropriate words.</h4>
          <br />
        </div>

        <section className={styles.sectionImageWords}>
          <div className={styles.imageContainer}>
            <img
              alt="Phrase"
              src={
                `${process.env.REACT_APP_CLOUDFRONT_DNS}/media/images/` +
                blockData.complement.image.img
              }
            />
          </div>

          <div className={styles.wordsContainer}>
            <div className={styles.wordsList}>
              {shuffledData.map(function ({ word, lastDroppedItem }, index) {
                return (
                  <Box
                    className={styles.customBox}
                    name={word}
                    type={word}
                    isDropped={isDropped(word)}
                    key={index}
                  />
                );
              })}
            </div>
          </div>
        </section>

        <section className={styles.sectionWords}>
          <div>
            {dustbins.map(function ({ word, lastDroppedItem }, index) {
              return (
                <Dustbin
                  accepts={word.replace("[", "")}
                  lastDroppedItem={lastDroppedItem}
                  name={word.replace("[", "")}
                  text={`${splitText(datas, index)}`}
                  onDrop={(item) => handleDrop(index, item)}
                  key={index}
                />
              );
            })}
            <span
              style={{
                lineHeight: "80px",
                whiteSpace: "pre-line",
              }}
            >
              &nbsp;{lastText(datas).replace(/-/g, "\n")}
            </span>
          </div>
        </section>

        <footer>
          {solved && (
            <button
              onClick={() => {
                tryAgain();
              }}
            >
              Try Again
            </button>
          )}

          <button
            onClick={async () => {
              if (solved) {
                setDroppedBoxNames([]);
                setDustbins([]);
                props.step("forward");
              } else {
                setSolved(true);
                solve();
              }

              await registerProgress(true, 100, 1);
            }}
            disabled={!isAllDropped()}
            style={{
              backgroundColor: !isAllDropped() ? "gray" : "",
              cursor: !isAllDropped() ? "not-allowed" : "pointer",
            }}
          >
            {solved ? "Done" : "Check"}
          </button>
        </footer>
      </div>
    </div>
  );
};
export default ImagePhraseType;
